export default __webpack_public_path__ + "static/social-feminicidio_en-8e397afeafde5c4f3fe4d5798362b0e6.png";